// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"0f959298","453":"127be8e2","597":"3d78afdf","713":"b4fc8dd7"}[chunkId] + ".chunk.js";
};